import SecureComponentContainer from './containers/SecureComponentContainer'

export default SecureComponentContainer
